module.exports = __webpack_public_path__ + "img/142.e31bea54.jpg";